import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type {
  CaixaSupplierSummary,
  CaixaSupplierSummaryParams,
  CaixaTransactionRow,
  CaixaTransactionsParams,
  ManualCaixaTransactionPayload,
  ManualCaixaTransactionResult,
  PageResponse,
  UndoCaixaTransactionResult,
} from "./types";

function buildCaixaQuery(params: CaixaTransactionsParams): string {
  const qs = new URLSearchParams({
    limit: String(params.limit),
    offset: String(params.offset),
  });

  if (params.search) qs.set("search", params.search);
  if (params.client) qs.set("client", params.client);
  if (params.store) qs.set("store", params.store);
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);

  return qs.toString();
}

export function listCaixaSupplierSummaries(
  params: CaixaSupplierSummaryParams,
  signal?: AbortSignal,
): Promise<PageResponse<CaixaSupplierSummary>> {
  const qs = new URLSearchParams({
    limit: String(params.limit),
    offset: String(params.offset),
  });

  if (params.search) qs.set("search", params.search);

  return apiFetch(`${ENDPOINTS.caixas.suppliers}?${qs.toString()}`, { signal });
}

export function listSupplierCaixaTransactions(
  supplierId: string,
  params: CaixaTransactionsParams,
  signal?: AbortSignal,
): Promise<PageResponse<CaixaTransactionRow>> {
  return apiFetch(
    `${ENDPOINTS.caixas.supplierTransactions(supplierId)}?${buildCaixaQuery(params)}`,
    { signal },
  );
}

export function undoCaixaTransaction(
  id: string,
): Promise<UndoCaixaTransactionResult> {
  return apiFetch(ENDPOINTS.caixas.undoTransaction(id), { method: "POST" });
}

export function createManualCaixaTransaction(
  id: string,
  payload: ManualCaixaTransactionPayload,
): Promise<ManualCaixaTransactionResult> {
  return apiFetch(ENDPOINTS.suppliers.boxTransactions(id), {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
